import { Box, Divider, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { COLORS } from '../../../../styles/colors'

import { ReactComponent as NotificationEmpty } from '../../../../assets/icons/notification_empty.svg'
import { selectPermissions } from '../../../../store/authSlice'
import { useAppSelector } from '../../../../store/hooks'

import ArrowNext from 'assets/ArrowNext'
import SettingLogo from 'assets/SettingLogo'
import { MainSidebarLink } from 'ui/sidebar/shared/MainSidebarLink/MainSidebarLink'
import { TypographyPrimary16B } from 'ui/typography/TypographyPrimary16B'
import UserMenu from '../UserMenu/UserMenu'

const SidebarSettings = ({
	setOpenNotifications,
	countNotif,
	openNotifications,
	notificationButtonRef,
}) => {
	const permissions = useAppSelector(selectPermissions)
	const handlerNotificationBar = () => {
		setOpenNotifications(prevState => !prevState)
	}

	const canManageUsers = useMemo(
		() => permissions && permissions.can_manage_users,
		[permissions],
	)

	return (
		<Stack direction='column' gap='8px'>
			<UserMenu />

			<Divider
				sx={{
					borderBottomWidth: 1,
					borderColor: COLORS.inputBorder,
				}}
			/>

			<Box
				ref={notificationButtonRef}
				onClick={handlerNotificationBar}
				role='button'
				tabIndex={0}
				onKeyDown={e =>
					(e.key === 'Enter' || e.key === ' ') && handlerNotificationBar()
				}
				sx={{
					padding: '0 12px',
					display: 'flex',
					alignItems: 'center',
					height: '40px',
					borderRadius: '12px',
					gap: '6px',
					cursor: 'pointer',
					backgroundColor: 'transparent',
					'&:hover svg, &:hover svg *': { stroke: COLORS.primaryFont },
					'&:hover .MuiTypography-root': { color: COLORS.primaryFont },
				}}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						position: 'relative',
						'& svg, & svg *': {
							stroke: openNotifications ? COLORS.primaryFont : COLORS.icon,
						},
					}}
				>
					<NotificationEmpty width='16px' height='16px' />
					{countNotif > 0 && (
						<span
							style={{
								width: '6px',
								height: '6px',
								backgroundColor: COLORS.orange,
								borderRadius: '50%',
								position: 'absolute',
								bottom: '2px',
								right: '1px',
							}}
						></span>
					)}
				</Box>
				<TypographyPrimary16B
					sx={{
						color: openNotifications ? COLORS.primaryFont : COLORS.black,
					}}
				>
					Уведомления
				</TypographyPrimary16B>
				<Typography
					sx={{
						fontSize: '12px',
						fontWeight: '500',
						lineHeight: '14.63px',
						color: COLORS.health,
						padding: 0,
					}}
				>
					{countNotif === 0 ? '' : `+${countNotif}`}
				</Typography>
				<Stack
					direction='column'
					alignItems='center'
					sx={{
						'& svg, & svg *': {
							stroke: openNotifications ? COLORS.primaryFont : COLORS.icon,
						},
					}}
				>
					<ArrowNext
						width={16}
						height={16}
						style={{
							transform: openNotifications ? 'rotate(90deg)' : 'rotate(270deg)',
						}}
					/>
				</Stack>
			</Box>

			{canManageUsers && (
				<MainSidebarLink
					to='/settings'
					icon={<SettingLogo width='18px' height='18px' />}
					textMenu='Настройки'
				/>
			)}
		</Stack>
	)
}

export default SidebarSettings
